export default __webpack_public_path__ + "static/media/intro2.eb5d368a.png";